<template>
    <div class="shorturl-bridge-page">
        <div class="shorturl-bridge-content">
            <div class="shorturl-spinner" aria-hidden="true"></div>
            <h1 class="shorturl-status">{{ statusText }}</h1>
            <p v-if="subStatusText" class="shorturl-sub-status">{{ subStatusText }}</p>
        </div>
    </div>
</template>

<script>
import { getAxios } from "@/lib/AxiosCall";

function normalizeShortKey(value) {
    return String(value || "").trim();
}

function pickResolvedUrl(payload) {
    if (!payload || typeof payload !== "object") return "";

    const candidates = [
        payload.url,
        payload.targetUrl,
        payload.redirectUrl,
        payload.originUrl,
        payload.originalUrl,
        payload.oriUrl,
        payload.longUrl,
        payload?.data?.url,
        payload?.data?.targetUrl,
        payload?.data?.redirectUrl,
        payload?.data?.originUrl,
        payload?.data?.originalUrl,
        payload?.data?.oriUrl,
        payload?.data?.longUrl,
    ];

    for (const candidate of candidates) {
        const value = String(candidate || "").trim();
        if (value) return value;
    }
    return "";
}

function normalizeRedirectUrl(url) {
    const raw = String(url || "").trim();
    if (!raw) return "";

    if (/^https?:\/\//i.test(raw)) {
        return raw;
    }

    if (raw.startsWith("/")) {
        return `${window.location.origin}${raw}`;
    }

    return "";
}

export default {
    name: "HFO_SH_001",
    data() {
        return {
            statusText: "링크 확인 중입니다...",
            subStatusText: "잠시만 기다려주세요.",
        };
    },
    async mounted() {
        await this.resolveAndRedirect();
    },
    methods: {
        async resolveAndRedirect() {
            const keyFromQuery = normalizeShortKey(this.$route?.query?.shortKey);
            const keyFromParam = normalizeShortKey(this.$route?.params?.shortKey);
            const shortKey = keyFromQuery || keyFromParam;

            if (!shortKey) {
                this.statusText = "잘못된 접근입니다.";
                this.subStatusText = "shortKey가 없습니다.";
                return;
            }

            try {
                const response = await getAxios("/hvm/v1/common/shorturl", { shortKey });
                const resolved = pickResolvedUrl(response);
                const targetUrl = normalizeRedirectUrl(resolved);

                if (!targetUrl) {
                    this.statusText = "링크를 찾을 수 없습니다.";
                    this.subStatusText = "잠시 후 다시 시도해주세요.";
                    return;
                }

                this.statusText = "페이지 이동 중입니다...";
                this.subStatusText = "";
                window.location.replace(targetUrl);
            } catch (error) {
                console.error("shorturl resolve error:", error);
                this.statusText = "링크 확인 중 오류가 발생했습니다.";
                this.subStatusText = "잠시 후 다시 시도해주세요.";
            }
        },
    },
};
</script>

<style scoped>
.shorturl-bridge-page {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: #fff;
}

.shorturl-bridge-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
}

.shorturl-spinner {
    display: inline-block;
    width: 40px;
    height: 40px;
    border: 3px solid #e5e7eb;
    border-top-color: #009ca6;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.shorturl-status {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #111827;
}

.shorturl-sub-status {
    margin: 0;
    font-size: 14px;
    color: #6b7280;
}
</style>
